import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { MijnKlantConversationalModule } from '../mijn-klant-conversational.module';

import { WrapperComponent } from './wrapper.component';

@NgModule({
    imports: [BrowserModule, MijnKlantConversationalModule],
    declarations: [WrapperComponent],
    exports: [WrapperComponent],
    bootstrap: [WrapperComponent]
})
export class WrapperModule {}
